<template>
    <div class="container-fluid py-2">
        <b-button @click="onClickAdd" class="px-5 mb-3" variant="primary"
            >Add</b-button
        >
        <b-table :fields="fields" :items="items">
            <template #cell(action)="data">
                <b-button
                    @click="onClickEdit(data)"
                    class="mr-1 mb-1"
                    variant="primary"
                    >Edit</b-button
                >
                <b-button
                    @click="onClickDetail(data)"
                    variant="primary"
                    class="mr-1 mb-1"
                    >Detail</b-button
                >
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            @change="onChangePage"
        ></b-pagination>
        <AddBalanceRecordModal
            v-model="modalAdd"
            :id="this.$route.params.accountId"
            :first-record="items.length > 0 ? items[0] : null"
            @onDone="fetchData"
        ></AddBalanceRecordModal>
    </div>
</template>

<script>
import { getBalanceRecords } from '@/services/aws.service';
import moment from 'moment';
import AddBalanceRecordModal from '@/views/Modals/AddBalanceRecordModal/AddBalanceRecordModal.vue';

export default {
    name: 'BalanceRecordsView',
    components: { AddBalanceRecordModal },
    data() {
        return {
            modalAdd: false,
            filter: {
                search: '',
                from: '',
                to: '',
            },
            items: [],
            perPage: 10,
            currentPage: 1,
            total: 0,
            fields: [
                {
                    key: 'date',
                    label: 'date',
                    formatter: (value) => {
                        return moment(value).format('YYYY/MM/DD');
                    },
                },
                {
                    key: 'recordType',
                    label: 'recordType',
                },
                {
                    key: 'paymentType',
                    label: 'paymentType',
                },
                {
                    key: 'amount',
                    label: 'amount',
                },
                {
                    key: 'discount',
                    label: 'discount',
                },
                {
                    key: 'discountAmount',
                    label: 'discountAmount',
                },
                {
                    key: 'fee',
                    label: 'fee',
                },
                {
                    key: 'paymentAmount',
                    label: 'paymentAmount',
                },
                {
                    key: 'balance',
                    label: 'balance',
                },
                {
                    key: 'remark',
                    label: 'remark',
                },
            ],
            isLoading: false,
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const { accountId } = this.$route.params;
            // Check id is existed
            if (!accountId) {
                this.$router.push({ name: 'home' });
            }
            const query = {
                // search: this.filter.search || undefined,
                from: this.filter.from
                    ? moment(this.filter.from).startOf('day').toISOString()
                    : undefined,
                to: this.filter.to
                    ? moment(this.filter.to).endOf('day').toISOString()
                    : undefined,
                page: this.currentPage,
                limit: this.perPage,
            };
            this.isLoading = true;
            this.$store.commit('loading/setLoading', true);
            console.log(accountId);
            getBalanceRecords(accountId, query)
                .then(({ data }) => {
                    const { records, paginate } = data;
                    this.items = records;
                    this.perPage = paginate.perPage;
                    this.currentPage = paginate.currentPage;
                    this.total = paginate.total;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.$store.commit('loading/setLoading', false);
                });
        },
        onChangePage(val) {
            this.currentPage = val;
            this.fetchData();
        },
        onClickAdd(data) {
            this.currentData = data;
            this.modalAdd = true;
        },
    },
};
</script>
